import axios from 'axios';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const LOGIN_URL = `${BASE_URL}/rest/v2.0/login`;
export const REST_URL = `${BASE_URL}/rest/v1.0`;

export const CHANGE_PASSSWORD_URL = `${LOGIN_URL}/changePassword/`;
export const GENDER_PREFERENCE_URL = `${REST_URL}/directory-gender-preference/{username}`;
export const GUEST_BILLING_VALIDATE_USERNAME_REGISTRATION_URL = `${REST_URL}/username-validation?withSuggestion=true`;
export const LOGIN_VERIFY_SECURITY_QUESTIONS_URL = `${LOGIN_URL}/secure`;
export const LOGIN_SECURITY_QUESTIONS_URL = `${LOGIN_VERIFY_SECURITY_QUESTIONS_URL}?username={username}`;
export const LOGOUT_URL = `${REST_URL}/login/logout`;
export const PASSWORD_RECOVERY_URL = `${LOGIN_URL}/passwordRecovery`;
export const REGISTRATION_URL = `${REST_URL}/register`;
export const STUDIO_EMAIL_SETTINGS = `${REST_URL}/studio/{studioOwnerName}/settings`;
export const STUDIO_REGISTRATION_URL = `${REST_URL}/studio`;
export const USER_CONSENT_URL_STATUS_APPROVED = `${BASE_URL}/rest/v1.0/user/{username}/consent/PERFORMER`;
export const USER_CREATE_URL = `${REST_URL}/users`;
export const USER_STATE_URL = `${LOGIN_URL}/user`;
export const USER_STATUS_URL = `${REST_URL}/accounts/{username}/status`;
export const VALIDATE_EMAIL = `${REST_URL}/email-validation`;
export const VALIDATE_EMAIL_REGISTRATION_URL = `${REST_URL}/email-validation?email={email}`;
export const VALIDATE_USERNAME = `${REST_URL}/login/validateUsername`;
export const VALIDATE_USERNAME_REGISTRATION_URL =
  `${REST_URL}/username-validation?username={username}&withSuggestion=true`;

const api = axios.create({ withCredentials: true });

api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error.response.data)
);

export default api;
